import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default component((node, ctx) => {
  const toggle = node.querySelector('.js-filter-dropdown-toggle');
  const filters = node.querySelector('.js-filter-dropdown-list');
  const clear = node.querySelector('.js-clear-filters');
  const mql = ctx.getState().isMobile;
  const isDesktop = ctx.getState().isDesktop.matches;
  let isExpanded = false;

  const headerHeight = () => ctx.getState().headerHeight;

  if ((window.location.href).includes('tagged')) {
    gsap.set(clear, { autoAlpha: 1 });
  } else {
    gsap.set(clear, { autoAlpha: 0 });
  }

  const toggleFilters = () => {
    $(filters).slideToggle(300);
    isExpanded = !isExpanded;
    gsap.set('.js-toggle-icon', {
      scaleY: isExpanded ? -1 : 1
    });
  };

  const createScrollTrigger = () => {
    if (!isDesktop) {
      ScrollTrigger.create({
        trigger: '.js-blog-filter',
        pin: true,
        start: `top ${headerHeight()}`,
        endTrigger: '.js-footer',
        end: 'top 50%',
        anticipatePin: true,
      });
    }
  };

  const closeDropdown = () => {
    isExpanded = false;
    $(filters).css('display', 'none');
    $('.js-toggle-icon').css('transform', 'scaleY(1)');
  };

  ctx.on('headerHeightUpdate', () => {
    createScrollTrigger();
  });

  mql.addEventListener('change', () => {
    if (!mql.matches) { // If is not mobile
      $(filters).css('display', 'flex');
    } else {
      closeDropdown();
    }
  });

  toggle.addEventListener('click', toggleFilters);
});